module.exports = "# Help\r\n\r\n* **How do I resize a single image?**\r\n\r\n  To resize a JPG or a PNG image, simply upload it to our single image editor here. Once the file is uploaded, you will be taken to our editor where you can select a new size for your image.\r\n\r\n* **How do I resize multiple images at once?**\r\n\r\n  To resize multiple images at once, you can upload or drag and drop your image files to our bulk resize page. Once your files are uploaded, you can select a new size for your files. New size can be specified as a percentage of original file or as an exact pixel amount.\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Help/help.md
// module id = 1173
// module chunks = 0